
import { useLocation, Link } from 'react-router-dom';
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { NotificationBell } from '../layout/notification-bell';

// Map routes to breadcrumb titles
const routeTitles: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/streams': 'Streams',
  '/comments': 'Comments',
  '/notifications': 'Notifications',
  '/profile': 'Profile',
  '/settings': 'Settings',
  '/admin': 'Administration',
  '/admin/streams': 'Manage Streams',
  '/admin/streams/new': 'Create Stream',
  '/admin/recordings': 'Recordings',
  '/admin/users': 'User Management',
  '/admin/audit-logs': 'Audit Logs',
  '/admin/live-inputs': 'Live Inputs',
  '/admin/requests': 'Access Requests',
  '/admin/webhooks': 'Webhooks',
  '/admin/moderation': 'Moderation',
  '/moderator': 'Moderator Dashboard',
  '/moderator/reports': 'Reports',
  '/pastor': 'Pastor Dashboard',
};

function getRouteTitle(pathname: string): string {
  if (routeTitles[pathname]) return routeTitles[pathname];
  // For dynamic segments like /admin/streams/:id, walk up path segments
  const parts = pathname.split('/');
  while (parts.length > 1) {
    parts.pop();
    const parent = parts.join('/');
    if (routeTitles[parent]) return routeTitles[parent];
  }
  return 'Dashboard';
}

interface SiteHeaderProps {
  title?: string;
}

export function SiteHeader({ title }: SiteHeaderProps) {
  const location = useLocation();
  const currentTitle = title || getRouteTitle(location.pathname);

  return (
    <header className="sticky top-0 z-40 flex h-(--header-height) shrink-0 items-center gap-2 border-b border-border/70 bg-card/80 backdrop-blur-md supports-[backdrop-filter]:bg-card/70 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-3 lg:gap-2 lg:px-5">
        <SidebarTrigger className="-ml-1 rounded-full hover:bg-accent/70" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="hidden lg:block">
              <BreadcrumbLink asChild>
                <Link to="/dashboard">
                  Dominion Mandate
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium">{currentTitle}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        
        {/* Spacer to push notification button to the right */}
        <div className="flex-1" />
        
        {/* Notification button */}
        <NotificationBell />
      </div>
    </header>
  );
}
